import { ECommerce } from "ui/forms/Onboarding";
import { Step, withStepData } from "ui/organizms/Onboarding/Applications/common";
import useBusinessInformation from "./useBusinessInformation";

const BusinessInformation = () => {
    const businessInformation = useBusinessInformation();

    return (
        <Step
            title='Business Information'
        >
            <ECommerce.BusinessInformation.Form
                {...businessInformation}
            />
        </Step>
    );
};

export default withStepData(BusinessInformation);
